module.exports = __webpack_public_path__ + "linkedin-52d514f9.webp";